import React from 'react'
import { Video as LucideVideo } from 'lucide-react'

// Media Gallery Component
interface MediaGalleryProps {
  media: {
    url: string
    type: 'image' | 'gif' | 'sticker' | 'video'
    width?: number
    height?: number
  }[]
  onMediaClick: (media: {
    url: string
    type: 'image' | 'gif' | 'sticker' | 'video'
  }) => void
}

const MediaGallery: React.FC<MediaGalleryProps> = ({ media, onMediaClick }) => {
  if (media.length === 1) {
    const item = media[0]
    return (
      <div
        className="relative cursor-pointer group overflow-hidden rounded-lg"
        onClick={() => onMediaClick(item)}
      >
        {item.type === 'video' ? (
          <video
            src={item.url}
            className="w-full h-auto object-cover rounded-lg transition-transform duration-300 group-hover:scale-105 bg-gray-100"
            style={{
              maxWidth: item.width ? `${item.width}px` : '100%',
              maxHeight: item.height ? `${item.height}px` : '400px',
            }}
            muted
            loop
            playsInline
            preload="metadata"
          />
        ) : (
          <img
            src={item.url}
            alt={`${item.type} media`}
            className="w-full h-auto object-cover rounded-lg transition-transform duration-300 group-hover:scale-105"
            style={{
              maxWidth: item.width ? `${item.width}px` : '100%',
              maxHeight: item.height ? `${item.height}px` : '400px',
            }}
          />
        )}
        {/* แสดงไอคอนตามประเภท media */}
        {item.type === 'video' && (
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none bg-black/20 group-hover:bg-black/30 transition-colors">
            <div className="bg-black/60 rounded-full p-3">
              <LucideVideo className="w-6 h-6 text-white opacity-80" />
            </div>
          </div>
        )}
        {item.type === 'gif' && (
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none bg-black/20 group-hover:bg-black/30 transition-colors">
            <div className="bg-black/60 rounded-full p-3">
              <span className="text-white font-bold text-sm">GIF</span>
            </div>
          </div>
        )}
        {item.type === 'sticker' && (
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none bg-black/20 group-hover:bg-black/30 transition-colors">
            <div className="bg-black/60 rounded-full p-3">
              <span className="text-white font-bold text-sm">😀</span>
            </div>
          </div>
        )}
      </div>
    )
  }

  // ถ้ามีหลายรูป แสดงแบบ grid
  return (
    <div className="grid grid-cols-2 gap-2">
      {media.map((item, index) => (
        <div
          key={index}
          className="relative cursor-pointer group overflow-hidden rounded-lg aspect-square"
          onClick={() => onMediaClick(item)}
        >
          {item.type === 'video' ? (
            <video
              src={item.url}
              className="w-full h-full object-cover rounded-lg transition-transform duration-300 group-hover:scale-105 bg-gray-100"
              muted
              loop
              playsInline
              preload="metadata"
            />
          ) : (
            <img
              src={item.url}
              alt={`${item.type} media ${index + 1}`}
              className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
            />
          )}
          {item.type === 'video' && (
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none bg-black/20 group-hover:bg-black/30 transition-colors">
              <div className="bg-black/60 rounded-full p-2">
                <LucideVideo className="w-4 h-4 text-white opacity-80" />
              </div>
            </div>
          )}
          {item.type === 'gif' && (
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none bg-black/20 group-hover:bg-black/30 transition-colors">
              <div className="bg-black/60 rounded-full p-2">
                <span className="text-white font-bold text-xs">GIF</span>
              </div>
            </div>
          )}
          {item.type === 'sticker' && (
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none bg-black/20 group-hover:bg-black/30 transition-colors">
              <div className="bg-black/60 rounded-full p-2">
                <span className="text-white font-bold text-xs">😀</span>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  )
}

export default MediaGallery
